import {AddSchema} from "mobx-graphlink";
import {GetValues_ForSchema} from "js-vextensions";
import {TriggerSet} from "../@TriggerSet.js";
import {Phase} from "../../@Shared/Phase.js";

export class EngineConfig_MicroSnooze {
	constructor(data: Partial<EngineConfig_MicroSnooze>) { Object.assign(this, data); }

	enabled: boolean;

	// triggers
	microSnooze_triggerSet: TriggerSet;

	tiltSnooze_enabled: boolean;
	tiltSnooze_minAngleFromFlat: number;
	tiltSnooze_maxTiltDuration: number;
	tiltSnooze_soundPath: string;
	tiltSnooze_soundVolume: number;

	/*onSolveStart_soundTagOverride: string;
	onSolveStart_lightTagOverride: string;*/
	// Why do we call this "max time for progress", when progress is not even possible for micro-snoozes? Reason: Just to have consistent field-naming with other solvers.
	maxTimeForProgress: number; // in seconds

	/** When a micro-snooze's solve period ends (fails), this mapping can override the "phase after solve-fail" setting from alarms config.
	 * Keys are the phase that was active prior to the solving phase; values are the phase to transition to afterward. */
	phaseAfterSolveFail_overrides: {[priorPhase: string]: Phase};
}
AddSchema("EngineConfig_MicroSnooze", {
	properties: {
		enabled: {type: "boolean"},
		microSnooze_triggerSet: {$ref: "TriggerSet"},

		tiltSnooze_enabled: {type: "boolean"},
		tiltSnooze_minAngleFromFlat: {type: "number"},
		tiltSnooze_maxTiltDuration: {type: "number"},
		tiltSnooze_soundPath: {type: "string"},
		tiltSnooze_soundVolume: {type: "number"},

		/*onSolveStart_soundTagOverride: {type: "string"},
		onSolveStart_lightTagOverride: {type: "string"},*/
		maxTimeForProgress: {type: "number"},
		phaseAfterSolveFail_overrides: {additionalProperties: {$ref: "Phase"}},
	},
});